import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import SupplementaryPromptEditPage from "./SupplementaryPromptEditPage";
import { tiny } from "../../../store/actions/contracts";
import { setV2 } from "../../../store/actions/pagesV2";

const mapStateToProps = (state: any) => ({
    tinyContracts: state.contracts.tiny || [],
});

const mapDispatchToProps = (dispatch: any) => ({
    actions: bindActionCreators({
        getTinyContracts: tiny,
        resetSelectedContracts: () => setV2('contractsv2-landing', 'selected', []),
        setSelectedContracts: (item: string[]) => setV2('contractsv2-landing', 'selected', item),
    }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(SupplementaryPromptEditPage)));
